// extracted by mini-css-extract-plugin
export default {"message":"ErrorPages_message__ugaPw","notFoundImage":"ErrorPages_notFoundImage__E8eer","description":"ErrorPages_description__f+0nf","mobile":"ErrorPages_mobile__gnnF1"};